import { Injectable, signal } from '@angular/core';

export interface Toast {
    message: string;
    type?: 'success' | 'error' | 'warning' | 'info';
    delay?: number;
}

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private readonly _toasts = signal<Toast[]>([]);
    readonly toasts = this._toasts.asReadonly();

    show(toast: Toast) {
        this._toasts.update((toasts) => [...toasts, toast]);
    }

    remove(toast: Toast) {
        this._toasts.update((toasts) => toasts.filter((t) => t !== toast));
    }

    success(message: string, delay = 5000) {
        this.show({ message, type: 'success', delay });
    }

    error(message: string, delay = 5000) {
        this.show({ message, type: 'error', delay });
    }

    warning(message: string, delay = 5000) {
        this.show({ message, type: 'warning', delay });
    }

    info(message: string, delay = 5000) {
        this.show({ message, type: 'info', delay });
    }

    clear() {
        this._toasts.set([]);
    }
}
